import React, { useEffect, useState } from "react";
import "./alert.css";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Grid,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Button,
  MenuItem,
  Skeleton,
  Menu,
  Tooltip,
} from "@mui/material";
import Swal from "sweetalert2";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import AddIcon from "@mui/icons-material/Add";
import BackDropLoaderApi from "../../Allloader/BackDropLoaderApi";
import StyledTableCell from "../../Tabletheme/Customtableheader";
import AlerttypesAdd from "../Alerts/AlertTypesAdd";
import AlertEdit from "../Alerts/AlertEdit";
import CustomTheme from "../../Customtheme/Themes"

const AlertTypes = () => {
  const { drawerWidth, isXs, isSm, isMd, isLg, isXl } = CustomTheme();
  const [selectedRowIndex, setSelectedRowIndex] = useState(null);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [pageNo, setPageNo] = useState(1);
  const [totalRecods, setTotalRecods] = useState(0);
  const [sortField, setSortField] = useState("alert_type_name");
  const [sortOrder, setSortOrder] = useState("asc");
  const [endPointTableData, setEndpointTableData] = useState([]);
  const [showmoreLoader, setShowmoreLoader] = useState(false);
  const [backDrop, setBackDrop] = useState(false);
  const [loader, setLoader] = useState(true);
  const [selectedItems, setSelectedItems] = useState([]);
  const [selectedInbound, setSelectedInbound] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isEditfactInbound, setIsEditfactInbound] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);
  const [value, setValue] = useState(null);
  const [selectedAlertOption, setSelectedAlertOption] = useState(null);
  const [searchText, setSearchText] = useState("");
  const [alertEdit, setAlertEdit] = useState("");
  const [isAddSectionOpen, setIsAddSectionOpen] = useState(false);
  const [isEditSectionOpen, setIsEditSectionOpen] = useState(false);


  const GetHandlingData = async (isSelected,alerttypeId) => {
    const body = {
        selected: isSelected ,
        alert_type_id:alerttypeId?alerttypeId:0
    }
   return await instance
      .post("api/v1/Master/AlertHandlingTrack/Get",body) 
  };
  const handleButtonClick = () => {
    setIsDrawerOpen(true);
    setIsAddSectionOpen(true);
    setIsEditSectionOpen(false);
  };

  const handleDrawerClose = (event) => {
      setIsDrawerOpen(false);
  };
  const handleEditClick = (event, index) => {
    setAnchorEl(event.currentTarget);
    setSelectedRowIndex(index);
  };
  const deleteAlertData = (entityId) => {
    instance
      .delete(`api/v1/Master/AlertType/Delete/${entityId}`)
      .then((res) => {
        const ResultData = res?.data?.ResultMessage ?? [];
        if (ResultData === "Deletion Success") {
          setEndpointTableData((prevData) => {
            return prevData.filter(row => row.alert_type_id !== entityId);
          });
            getAlterTypes();
          Swal.fire({
            icon: "success",
            title: "Deleted!",
            text: ResultData,
            customClass: {
              confirmButton: "custom-confirm-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
            allowOutsideClick: false,
          });
        } else {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: ResultData,
            customClass: {
              confirmButton: "custom-cancle-button-class",
            },
            buttonsStyling: false,
            showCancelButton: false,
            confirmButtonText: "OK",
          });
        }
      })
      .catch((err) => {
        console.log("newData12", err);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Something went wrong!",
          customClass: {
            confirmButton: "custom-cancle-button-class",
          },
          buttonsStyling: false,
          showCancelButton: false,
          confirmButtonText: "OK",
        });
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  const handleEdit = (event, singleRowInformation, index) => {
    if (event.target.innerText === "Edit") {
      setAlertEdit(singleRowInformation);
      setIsDrawerOpen(true);
      setIsAddSectionOpen(false);
      setIsEditSectionOpen(true);
      setAnchorEl(null);
      setSelectedRowIndex(null);
    } else if (event.target.innerText === "Delete") {
      Swal.fire({
        icon: "question",
        text: "Are you sure you want to delete",
        customClass: {
          confirmButton: "custom-confirm-button-class",
          cancelButton: "custom-cancle-button-class",
        },
        buttonsStyling: false,
        showCancelButton: true,
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        allowOutsideClick: false,
        reverseButtons: true, 
      }).then((responce) => {
        if (responce?.isConfirmed) {
          deleteAlertData(singleRowInformation?.alert_type_id);
        } else {
        }
      });
    }
    setAnchorEl(null);
    setSelectedRowIndex(null);
  };
  const handleSort = (field) => {
    const order = field === sortField && sortOrder === "asc" ? "desc" : "asc";
    console.log("field", order);
    setSortField(field);
    setSortOrder(order);
    getAlterTypes(pageNo, field, order);
  };
  const getAlterTypes = (
    pageNumber = pageNo,
    field = sortField,
    order = sortOrder,
    searchinfo = searchText
  ) => {
    const body = {
      id: "",
      searchtext: searchinfo,
      pageno: pageNumber,
      pagesize: 10,
      sortby: field ?? "",
      sortord: order ?? "",
    };
    instance
      .post("api/v1/Master/AlertType/Get", body)
      .then((res) => {
        setTotalRecods(res?.data?.Records ?? 0);
        if (pageNumber == 1) {
          setEndpointTableData(res?.data?.Value ?? []);
        } else {
          setEndpointTableData((prevData) => [
            ...prevData,
            ...res?.data?.Value,
          ]);
        }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoader(false);
        setShowmoreLoader(false);
      });
  };
  useEffect(() => {
    getAlterTypes(pageNo, sortField, sortOrder);
  }, [sortField, sortOrder]);

  
  
  console.log(endPointTableData, "endPointTableData");
  return (
    <>
      <div className="parentAlert_div">
        <div
          style={{ display: "flex", justifyContent: "space-between" }}
          className="mb-4"
        >
          <p className="headingAlert_font">Alert Types</p>
          <p className="headAlert_div"></p>
        </div>
        {backDrop && <BackDropLoaderApi open={backDrop} />}
        <Grid container justifyContent="space-between" spacing={2}>
          <Grid item xl={1.6} lg={3} md={6} sm={12} xs={12}>
            <Button
              variant="contained"
              className="button_headerAlert"
              onClick={handleButtonClick}
              color="secondary"
              sx={{
                width: "100%",
              }}
            >
              Add Alert Type <AddIcon />
            </Button>
          </Grid>
          <Grid item xl={3} lg={3} md={6} sm={12} xs={12}>
            <div className="search-sectionEndpoint d-flex">
              <div>
                <img src="assets/Images/searchicon.svg" alt="Search Icon" />
              </div>
              <div className="search-inputEndpoint">
                <input
                  onKeyUp={(event) => {
                    if (event.key === "Enter") {
                      getAlterTypes(
                        1,
                        sortField,
                        sortOrder,
                        event.target.value
                      );
                    }
                  }}
                  onChange={(event) => {
                    setSearchText(event.target.value);
                    if (event.target.value.length === 0) {
                      getAlterTypes(1, sortField, sortOrder, "");
                    }
                  }}
                  type="text"
                  placeholder="Search"
                />
              </div>
            </div>
          </Grid>
        </Grid>
        {isAddSectionOpen && (
          <AlerttypesAdd
            isOpen={isDrawerOpen}
            setIsopen={setIsDrawerOpen}
            handleClose={handleDrawerClose}
            getAlterTypes={getAlterTypes}
            GetHandlingData={GetHandlingData}
          
          />
        )}
        {isEditSectionOpen && (
          <AlertEdit
            isOpen={isDrawerOpen}
            setIsopen={setIsDrawerOpen}
            handleClose={handleDrawerClose}
            alertEdit={alertEdit}
            setAlertEdit={setAlertEdit}
            getAlterTypes={getAlterTypes}
            GetHandlingData={GetHandlingData}
           
          />
        )}
        <TableContainer sx={{ marginTop: 5, maxHeight: 600 }} component={Paper}>
          <Table stickyHeader>
            <TableHead>
              <TableRow className="Table_row">
                <StyledTableCell onClick={() => handleSort("alert_type_name")}>
                  Name
                  {sortField === "alert_type_name" && (
                    <>
                      {sortOrder === "asc" ? (
                        <img
                          src="assets/Images/Ascending.svg"
                          alt="Ascending"
                          style={{ width: "5%", marginLeft: "5px" }}
                        />
                      ) : (
                        <img
                          src="assets/Images/descending.svg"
                          alt="Descending"
                          style={{ width: "5%", marginLeft: "5px" }}
                        />
                      )}
                    </>
                  )}
                </StyledTableCell>
                <StyledTableCell>Description</StyledTableCell>
                <StyledTableCell>Category</StyledTableCell>
                <StyledTableCell sx={{ width: "10%" }}>
                  Appears on Message Type
                </StyledTableCell>
                <StyledTableCell>Retries</StyledTableCell>
                <StyledTableCell>Interval</StyledTableCell>
                <StyledTableCell>Associated Message</StyledTableCell>
                <StyledTableCell>Always Logged</StyledTableCell>
                <StyledTableCell />
              </TableRow>
            </TableHead>
            {loader ? (
              <>
                {new Array(5).fill(3).map((element, index) => {
                  return (
                    <TableRow key={index}>
                      {new Array(9).fill(1).map((element, index) => {
                        return (
                          <TableCell align="center" key={index}>
                            <Skeleton
                              variant="rounded"
                              width={"100%"}
                              height={60}
                            />
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
              </>
            ) : (
              <>
                {endPointTableData.length === 0 ? (
                  <TableRow>
                    <TableCell colSpan={7} align="center">
                      <p>No Data Found</p>
                    </TableCell>
                  </TableRow>
                ) : (
                  <TableBody>
                    {endPointTableData.map((singleRowInformation, index) => (
                      <TableRow key={index}>
                           {/* <TableRow key={singleRowInformation?.id}></TableRow> */}
                        <TableCell style={{ minWidth: "16rem", maxWidth: "16rem", overflow: "hidden",
                          textOverflow: "ellipsis"}}>
                              <Tooltip
                            title={singleRowInformation?.alert_type_name}
                            arrow
                            placement="top"
                          >
                             {singleRowInformation?.alert_type_name?.length > 30
                                ? singleRowInformation?.alert_type_name.substring(0, 30) +
                                  "..."
                                : singleRowInformation?.alert_type_name}
                              </Tooltip>
                        </TableCell>
                        <TableCell style={{ minWidth: "27rem", maxWidth: "27rem", overflow: "hidden",
                          textOverflow: "ellipsis"}}>
                             <Tooltip
                            title={singleRowInformation?.alert_type_desc}
                            arrow
                            placement="top"
                          >
                             {singleRowInformation?.alert_type_desc?.length >150
                                ? singleRowInformation?.alert_type_desc.substring(0, 150) +
                                  "..."
                                : singleRowInformation?.alert_type_desc}
                              </Tooltip>
                        </TableCell>
                        <TableCell style={{ minWidth: "16rem", maxWidth: "16rem", overflow: "hidden",
                          textOverflow: "ellipsis"}}>
                             <Tooltip
                            title={singleRowInformation?.alert_category_name}
                            arrow
                            placement="top"
                          >
                             {singleRowInformation?.alert_category_name?.length > 30
                                ? singleRowInformation?.alert_category_name.substring(0, 30) +
                                  "..."
                                : singleRowInformation?.alert_category_name}
                              </Tooltip>
                        </TableCell>
                        <TableCell padding="checkbox" style={{ minWidth: "8rem", maxWidth: "8rem"}}>
                          <Checkbox
                            color="secondary"
                            checked={
                              singleRowInformation?.show_for_message_type
                            }
                          />
                        </TableCell>
                        <TableCell style={{ minWidth: "2rem", maxWidth: "2rem"}}>
                          {singleRowInformation?.alert_retry_num}
                        </TableCell>
                        <TableCell style={{ minWidth: "2rem", maxWidth: "2rem"}}>
                          {singleRowInformation?.alert_retry_interval}
                        </TableCell>
                        <TableCell style={{ minWidth: "8rem", maxWidth: "8rem"}}>
                          {singleRowInformation?.message_status_name}
                        </TableCell>
                        <TableCell padding="checkbox" style={{ minWidth: "10rem", maxWidth: "10rem"}}>
                          <Checkbox
                            color="secondary"
                            checked={singleRowInformation?.is_always_logged}
                          />
                        </TableCell>
                        <TableCell style={{ minWidth: "3rem", maxWidth: "3rem"}}>
                          <div style={{ textAlign: "center" }}>
                            <MoreVertIcon
                              onClick={(event) => handleEditClick(event, index)}
                              id="basic-button"
                              aria-controls={
                                Boolean(anchorEl)
                                  ? `basic-menu-${index}`
                                  : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={
                                Boolean(anchorEl) ? "true" : undefined
                              }
                            />
                            <Menu
                              id={`basic-menu-${index}`}
                              anchorEl={anchorEl}
                              open={
                                selectedRowIndex !== null &&
                                selectedRowIndex === index
                              }
                              onClose={handleEdit}
                              MenuListProps={{
                                "aria-labelledby": `basic-button-${index}`,
                              }}
                            >
                              <MenuItem
                                onClick={(event) => {
                                  handleEdit(
                                    event,
                                    singleRowInformation,
                                    index
                                  );
                                }}
                              >
                                Edit
                              </MenuItem>
                              <MenuItem
                                onClick={(event) => {
                                  handleEdit(
                                    event,
                                    singleRowInformation,
                                    index
                                  );
                                }}
                              >
                                Delete
                              </MenuItem>
                            </Menu>
                          </div>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                )}
              </>
            )}
          </Table>
        </TableContainer>
        <Grid item xs={12} className="mt-4" sx={{ textAlign: "center" }}>
          {endPointTableData.length > 0 &&
            totalRecods > endPointTableData.length && (
              <Button
                id="back-button"
                variant="contained"
                color="secondary"
                sx={{ textTransform: "none" }}
                onClick={() => {
                  setShowmoreLoader(true);
                  setPageNo((prev) => prev + 1);
                  getAlterTypes(pageNo + 1 , sortField, sortOrder);
                }}
              >
                {showmoreLoader ? "loading" : "Show More"}
              </Button>
            )}
        </Grid>
      </div>
    </>
  );
};

export default AlertTypes;
